<template>
  <BaseView :ignoreOffline="true">
    <template v-slot:top>
        <Navigation :is-on-free-plan="isOnFreePlan" />
        <inspection-count
            v-if="isOnFreePlan"
            :user="user"
        />
    </template>

    <div v-pull-to-refresh="refreshInspections">
        <div v-if="inspections.length === 0" class="middle-of-page">
            {{ $t("No check to do") }}
        </div>

        <div v-for="todo in inspections" :key="todo.id">
            <TodosInspection
                :todo="todo"
                @click.native="todoInspectionClicked(todo)"
            />
        </div>
    </div>

    <template v-slot:bottom>
        <bottom-navigation />
    </template>

    <portal to="modals">
      <transition name="fade">
        <TodosInspectionModal
          v-if="isInspectionModalOpened"
          :todo="selectedTodo"
          @resumeDraft="resumeDraft"
          @restartInspection="restartInspection"
          @startInspection="startInspection"
          @close="modalClosed"
        />
      </transition>
    </portal>

  </BaseView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TodosInspection from '@mobile/views/Todos/Items/Inspection.vue';
import TodosInspectionModal from '@mobile/views/Todos/Modals/InspectionDetails.vue';
import InspectionCount from '@mobile/components/InspectionCount.vue';
import BaseView from '@mobile/components/BaseView.vue';
import draftDB from '@mobile/db/drafts';
import Navigation from './components/Navigation';
import OnFreePlan from '@mobile/mixins/OnFreePlan';
import { eventBus } from '@/eventBus';

export default {
    name: 'TodoInspections',

    mixins: [
        OnFreePlan,
    ],

    components: {
        TodosInspection,
        TodosInspectionModal,
        Navigation,
        BaseView,
        InspectionCount,
    },
    props: {
        todoId: {
            type: String,
            default: null,
        },
    },

    created() {
        this.refreshInspections();
    },

    data: () => ({
        selectedTodo: null,
        sendingQueue: false,
    }),

    computed: {
        ...mapGetters({
            inspections: 'todos/inspections',
        }),

        isInspectionModalOpened() {
            return this.selectedTodo;
        },

    },

    methods: {
        ...mapActions({
            updateAll: 'todos/updateAll',
        }),

        todoInspectionClicked(todo) {
            this.selectedTodo = todo;
        },

        modalClosed() {
            this.selectedTodo = null;
        },

        startInspection() {
            this.$router.push({
                name: 'conduct',
                params: {
                    type: 'todo',
                    resourceId: this.selectedTodo.id,
                },
            });
        },

        async restartInspection() {
            // get draft is any
            const draft = await draftDB.get(this.selectedTodo.draft);

            // delete it
            if (draft) {
                await this.$store.dispatch('drafts/delete', draft.id);
            }

            // detach from todo
            if (this.selectedTodo.draft) {
                await this.$store.dispatch('todos/detachDraft', this.selectedTodo.id);
            }

            // start normal flow
            return this.startInspection();
        },

        async resumeDraft() {
            const draft = await draftDB.get(this.selectedTodo.draft);
            if (!draft) return this.startInspection();

            return this.$router.push({
                name: 'conduct',
                params: {
                    type: 'draft',
                    resourceId: this.selectedTodo.draft,
                },
            });
        },

        refreshInspections() {
            return this
                .updateAll()
                .then(() => {
                    eventBus.$emit('loaded');
                })
                .catch((error) => {
                    eventBus.$emit('client-error', error);
                });
        },
    },
};
</script>
